// extracted by mini-css-extract-plugin
export default {"root":"FileDropzone_root__a4NRb","inner":"FileDropzone_inner__UVclt"};